import { useMemo } from 'react';
import { formatDate as fmtDate, formatDateTime as fmtDateTime, formatTime as fmtTime, } from '../formatting/date-format';
import { formatCurrency as fmtCurrency, formatNumber as fmtNumber, } from '../formatting/number-format';
import { formatRelativeTime as fmtRelativeTime } from '../formatting/relative-time-format';
import { useLanguage } from '../i18n/LanguageContext';
import { useLocale } from '../i18n/LocaleContext';
export function useFormatting() {
    const { locale } = useLocale();
    const { language } = useLanguage();
    return useMemo(() => ({
        locale,
        language,
        formatDate: (isoString) => fmtDate(isoString, locale),
        formatTime: (isoString) => fmtTime(isoString, locale),
        formatDateTime: (isoString) => fmtDateTime(isoString, locale),
        formatNumber: (value) => fmtNumber(value, locale),
        formatCurrency: (value, currency) => fmtCurrency(value, currency, locale),
        formatRelativeTime: (isoString) => fmtRelativeTime(isoString, language),
    }), [locale, language]);
}
